import t from"./_baseIsMatch.js";import r from"./_getMatchData.js";import a from"./_matchesStrictComparable.js";var o=t,e=r,m=a;var n=function(t){var r=e(t);return 1==r.length&&r[0][2]?m(r[0][0],r[0][1]):function(a){return a===t||o(a,t,r)}};export{n as default};
//# sourceMappingURL=_baseMatches.js.map
